// extracted by mini-css-extract-plugin
export default {"noRoomContainer":"HotelNoRoom_noRoomContainer__FNqgF","noRoomImage":"HotelNoRoom_noRoomImage__kM9v-"};